// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"638":"8a157744","905":"335a909f"}[chunkId] + ".chunk.js";
};